export * from "react-native-web"
// export * from "react-native"
export const ViewPropTypes = {}
